
import Diamonds from "../../../assets/filled/Diamonds.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DiamondsIcon({ className, dataTestid = "DiamondsIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Diamonds data-testid={dataTestid} className={classes} {...rest} />
  );
}
